import React from "react";
import headerBg from "./assets/picOne.png";

const MbstTrainings = () => {
  const trainings = [
    {
      sn: 1,
      title: "Food Safety Management — Requirements for Good Hygienic Practices based on MS 21:2025  ",
      target: "Top management for organisations i.e. Chief Executive Officers, Directors, and Managers",
      duration: "21 - 23 January 2026 (3 days)"
    },
    {
      sn: 2,
      title: "Hazard Analysis and Critical Control Points (HACCP) System Development based on  MS 300 and Pre-Requisites Programmes (PRPs)",
      target: "Those responsible for quality of operations and processes, supervisors, managers and management representatives who would be key in the development of a Quality Management System",
      duration: "17 - 20 February 2026 (4 days)"
    },
    {
      sn: 3,
      title: "Quality Management Systems Development based on MS-ISO 9001:2015 ",
      target: "As in course number 2 above. Attendance of QMS development training is a prerequisite for this course",
      duration: "9 - 13 March 2026 (4.5 days)"
    },
    {
      sn: 4,
      title: "Quality Management Systems Internal Auditing based on MS - ISO 19011:2018",
      target: "Officers, Technicians and Assistants working in testing and calibration laboratories and instrumentation workshops. General workforce as quality is the responsibility of all workers",
      duration: "23 - 27 March 2027 (4.5 days)"
    },
    {
      sn: 5,
      title: "Quality Management Systems —Top Management Awareness based on MS-ISO 9001:2015",
      target: "All workers",
      duration: "10 April 2026 (0.5 days)"
    },
    {
      sn: 6,
      title: "Food Safety Management Systems Development based MS-ISO 22000: 2018 ",
      target: "Those in food production and processing facilities i.e. supervisors, managers and management representatives involved in the development and implementation of food safety management system",
      duration: "13 - 17 April 2026 (4.5 days)"
    },
    {
      sn: 7,
      title: "Food Safety Management Systems Internal Auditing based on MS-ISO 19011:2018",
      target: "Those in food production and processing facilities i.e. supervisors, food handlers, managers and management representatives",
      duration: "20 - 24 April 2026 (4.5 days)"
    },
    {
      sn: 8,
      title: "Food Safety System Certification Development and Implementation based on FSSC 22000 V6 and sector specific pre-requisite programme standards",
      target: "Top management for organisations i.e. Chief Executive Officers, Directors, and Managers",
      duration: "4 - 8 May 2026 (4.5 days)"
    },
    {
      sn: 9,
      title: "Educational Organization Management System (EOMS) Development based on MS-ISO 21001:2025",
      target: "General workforce working in food processing establishments",
      duration: "On demand (4.5 days)"
    },
    {
      sn: 10,
      title: "Educational Organization Management System (EOMS) Top Management Awareness based on MS-ISO 21001:2025",
      target: "Those responsible for environmental and waste management, pollution control and related operations both in government, non-governmental, and private organisations",
      duration: "On demand (0.5 day)"
    },
    {
      sn: 11,
      title: "Environmental Management System and Occupational Health and Safety Management Systems awareness based on MS-ISO 14001:2015 and MS-ISO 45001:2018Environmental Management Systems (EMS) Top Management Awareness (BS/QAD/20/10/02)",
      target: "Top management for organisations i.e. Chief Executive Officers, Directors, and Managers",
      duration: "11 June 2026 (1 day)"
    },

    {
      sn: 12,
      title: "Environmental Management System Development and Implementation based on MS-ISO 14001:2015",
      target: "Top management for organisations i.e. Chief Executive Officers, Directors, and Managers",
      duration: "22 - 26 June 2026 (4.5 days)"
    },

    {
      sn: 13,
      title: "Occupational Health and Safety Management Systems Development and implementation based on MS-ISO 45001:2018",
      target: "Top management for organisations i.e. Chief Executive Officers, Directors, and Managers",
      duration: "13 - 17 July 2026 (4.5 days)"
    },

    {
      sn: 14,
      title: "Food Safety Management — Requirements for Good Hygienic Practices and Food Labelling based on MS 21:2025 and MS 19-1:2024",
      target: "Top management for organisations i.e. Chief Executive Officers, Directors, and Managers",
      duration: "24 - 27 August 2026 (4 days)"
    },

    {
      sn: 15,
      title: "Risk Management Systems implementation based on MS-ISO 31000:2018",
      target: "Top management for organisations i.e. Chief Executive Officers, Directors, and Managers",
      duration: "21- 25 September 2026 (4.5 days)"
    },

    {
      sn: 16,
      title: "Laboratory Quality Management Systems Development according to MS-ISO 17025: 2017",
      target: "Top management for organisations i.e. Chief Executive Officers, Directors, and Managers",
      duration: "12 - 16 October 2026 (4.5 days)" 
    },

  ];

  return (
    <div className="about-us">
      {/* Header with overlay */}
      <section
        className="about-header"
        style={{
          backgroundImage: `url(${headerBg})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          height: "45vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center"
        }}
      >
        <div className="overlay">
          <h1 className="page-title">Trainings</h1>
          {/* <p className="subtitle">
            A complete list of training courses offered by the Malawi Bureau of Standards (MBS).
          </p> */}
        </div>
      </section>

      {/* Training Table */}
      {/* Training Table */}
<section style={{ maxWidth: "1400px", margin: "50px auto", padding: "0 20px" }}>
  
  {/* Intro Text */}
  <div className="training-intro">
    <h2>INDUSTRIAL RESEARCH, TRAINING AND CONSULTANCY UNIT (IRTACU)</h2>
    <p>
      The Malawi Bureau of Standards (MBS) IRTACU is pleased to announce training
      courses in quality management, food safety management, food and personal
      hygiene for food handlers, occupational health and safety management system,
      laboratory quality management and quality management systems auditing to be
      offered from January – December, 2026 at MBS Head Office in Blantyre as below:
    </p>
  </div>

  <table className="training-table">

          <thead>
            <tr>
              <th>S/N</th>
              <th>TRAINING COURSE</th>
              {/* <th>Target Group</th> */}
              <th>DATES AND DURATION</th>
            </tr>
          </thead>
          <tbody>
            {trainings.map((course) => (
              <tr key={course.sn}>
                <td>{course.sn}</td>
                <td>{course.title}</td>
                {/* <td>{course.target}</td> */}
                <td>{course.duration}</td>
              </tr>
            ))}
          </tbody>
        </table>

        {/* Notes & Contact Information */}
<div className="training-notes">
  <p>
    <strong>Note:</strong> The training dates are indicative and any changes to
    these dates will be communicated to the participants who have registered for
    the respective courses.
  </p>

  <p>
    <strong>Tailor-made training arrangements:</strong> These courses can also be
    offered for a group at requested locations and dates advised by the clients.
  </p>

  <p>
    For more details on each course, clarifications and registrations, please
    contact us through{" "}
    <a href="mailto:samsonmpaso@mbsmw.org">samsonmpaso@mbsmw.org</a> or{" "}
    <a href="mailto:lucksonzidana@mbsmw.org">lucksonzidana@mbsmw.org</a>.
  </p>

  <p>
    <strong>Other Information:</strong> The MBS offers other services and more
    information for the same can be obtained from the website{" "}
    <a href="https://www.mbsmw.org" target="_blank" rel="noopener noreferrer">
      www.mbsmw.org
    </a>{" "}
    or by writing to:
  </p>

  <div className="mbs-address">
    <p><strong>The Director General</strong></p>
    <p>Malawi Bureau of Standards</p>
    <p>P O Box 946</p>
    <p>Blantyre</p>
    <p>Tel: +265 1 870 488 / 0887 376 / 444 / 445 / 446 / 447</p>
    <p>Fax: +265 1 870 756</p>
    <p>Email: <a href="mailto:mbs@mbsmw.org">mbs@mbsmw.org</a></p>
  </div>
</div>

      </section>

      {/* Inline CSS */}
      <style>{`

      .training-notes {
  margin-top: 30px;
  font-size: 0.95rem;
  color: #444;
  line-height: 1.6;
}

.training-notes p {
  margin-bottom: 12px;
}

.training-notes a {
  color: #ff6600;
  font-weight: 500;
  text-decoration: none;
}

.training-notes a:hover {
  text-decoration: underline;
}

/* Centralised Address */
.mbs-address {
  margin-top: 20px;
  text-align: center;
}

.mbs-address p {
  margin: 4px 0;
  font-weight: 500;
}


        .overlay {
          background: rgba(0,0,0,0.55);
          padding: 40px;
          text-align: center;
          color: white;
          width: 90%;
          max-width: 1200px;
          border-radius: 12px;
        }
        .page-title {
          font-size: 2.5rem;
          font-weight: bold;
          margin-bottom: 15px;
        }
        .subtitle {
          font-size: 1.1rem;
          margin-top: 5px;
          font-weight: 500;
        }
        .training-table {
          width: 100%;
          border-collapse: collapse;
          margin-top: 20px;
          font-size: 1rem;
        }
        .training-table th, .training-table td {
          border: 1px solid #ddd;
          padding: 12px 15px;
          text-align: left;
        }
        .training-table th {
          background-color: #ff6600;
          color: white;
          font-weight: 600;
        }
        .training-table tbody tr:nth-child(even) {
          background-color: #f9f9f9;
        }
        .training-table tbody tr:hover {
          background-color: #ffe5cc;
          transform: scale(1.02);
          box-shadow: 0 4px 12px rgba(0,0,0,0.1);
        }
        @media screen and (max-width: 768px) {
          .overlay { padding: 25px; }
          .page-title { font-size: 2rem; }
          .training-table th, .training-table td { padding: 10px 8px; font-size: 0.9rem; }
        }
      `}</style>
    </div>
  );
};

export default MbstTrainings;
